"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferStepBasicInfoCreate = void 0;
var OfferStepBasicInfoCreate_1 = require("./OfferStepBasicInfoCreate");
Object.defineProperty(exports, "OfferStepBasicInfoCreate", { enumerable: true, get: function () { return OfferStepBasicInfoCreate_1.OfferStepBasicInfoCreate; } });
